<template>
  <div>
     <div v-if="submit_loader" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255, 255, 255, 0.31)">
          <div class="text-xs-center">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="#ff9233"
                class="text-xs-center my-5"
                large
            ></v-progress-circular>
          </div>
      </div> 
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form
              id="createRailwayPenalty"
              @submit.prevent="validateBeforeSubmit('createRailwayPenalty')"
              data-vv-scope="createRailwayPenalty"
              v-model="valid"
            >
              <v-card-text>
                <v-container
                  fluid
                  grid-list-md
                  style="padding: 0px 0px 0px 0px"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Title: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="title"
                        v-model="railway_penalty_object.title"
                        label="Title"
                         v-validate="'required'"
                        :error-messages="
                          errors.collect('createRailwayPenalty.title')
                        "
                        clearable
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Description: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-textarea
                        name="description"
                        v-model="railway_penalty_object.description"
                        clearable
                      ></v-textarea>
                      
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Penalty: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="penalty"
                        v-model="railway_penalty_object.penalty"
                        label="Railway Penalty"
                         v-validate="'required'"
                        :error-messages="
                          errors.collect('createRailwayPenalty.penalty')
                        "
                        clearable
                      ></v-text-field>
                       
                    </v-flex>
                  </v-layout> 
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Ref Links: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="ref_link"
                        v-model="railway_penalty_object.ref_link"
                        label="Refer Link"
                        clearable
                      ></v-text-field>
                       
                    </v-flex>
                  </v-layout> 
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Section No: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="section_no"
                        type="number"
                        v-model="railway_penalty_object.section_no"
                        label="Section No"
                        clearable
                      ></v-text-field>
                       
                    </v-flex>
                  </v-layout> 
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="!valid" type="submit"
                  >create
                </v-btn>
                <v-btn flat small to="/railway-penalty-list">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
import { VueEditor } from "vue2-editor";

export default {
  name: "Create",
  components: {
    VueEditor,
  },
  data: () => {
    return {
     railway_penalty_object:{
        title:"",
       description:"",
       penalty:"",
       ref_link:"",
       section_no:"",
       
     },

      submit_loader: false,
      valid:false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
    };
  },
 

  methods: {
  

    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    createRailwayPenalty: function () {
      this.submit_loader = true;
      let new_railway_penalty_details = Object.assign({}, this.railway_penalty_object);

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/store-railway-penalty`,new_railway_penalty_details,
           { headers: this.$headers }
        )
       
        .then((response) => {
          if (response.data.status == 1) {
           

            this.submit_loader = true;
            this.snackBar.show = true;
            this.snackBar.message = response.data.message;
            this.railway_penalty_object = '';
            // this.$router.push({name:"Ecart-Booking-list"});  
          } else {
       
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.submit_loader = false;
        });
    },
  
  },
  
};
</script>

<style type="text/css">
  .accent--text {
    color: #f67656;
    caret-color: #383859;
}
</style>

